import { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import Layout from './layout'
import { composeSteps, buildPrepareRegisterPayload } from './utils'
import { usePrepareRegisterGroupEvent } from '../queries'
import CircularProgress from '@material-ui/core/CircularProgress'
import Error from 'components/error'
import RegistrationComplete from '../components/registration-complete'
import { useAuth } from 'lib/auth'

const RegistrationWithPaymentIntents = props => {
  const [activeStep, setActiveStep] = useState(0)
  const [shouldFetchClientSecret, setShouldFetchClientSecret] = useState(false)
  const form = useFormContext()
  const { paymentRequired, shouldShowWaiver, groupEvent } = props
  const { user } = useAuth()
  const steps = composeSteps({ shouldShowWaiver, paymentRequired })
  const { prepareRegisterGroupEvent } = usePrepareRegisterGroupEvent()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [product, setProduct] = useState(null)

  const onSubmit = async () => {
    const { participants, contact } = buildPrepareRegisterPayload(
      form.getValues(),
    )

    const isCoach = user?.id === groupEvent?.coach?.id
    const isAssistantCoach = groupEvent?.assistantCoaches?.some(
      coach => coach.id === user?.id,
    )
    const shouldSkipPayment = isCoach || isAssistantCoach

    try {
      const { data, error, loading } = await prepareRegisterGroupEvent({
        variables: {
          input: {
            id: groupEvent.id,
            participants,
            contact,
            skipPayment: shouldSkipPayment,
          },
        },
      })
      setLoading(!!loading)
      if (error) {
        setError(error)
        return
      }
      if (data?.prepareRegisterGroupEvent?.success) {
        setProduct(data.prepareRegisterGroupEvent?.products[0])
      }
    } catch (error) {
      setError(error)
    }
  }

  const handleNext = async ({ fieldsToValidate = false }) => {
    const isValid = fieldsToValidate
      ? await form.trigger(fieldsToValidate)
      : await form.trigger()
    if (!isValid) {
      window.scrollTo({
        top: 80,
        left: 0,
        behavior: 'smooth',
      })
      return
    }

    if (steps.length === 1) {
      await onSubmit()
      return
    }

    setActiveStep(prevStep => {
      const currentStepName = steps[prevStep]?.name
      const nextStep = prevStep + 1
      const nextStepName = steps[nextStep]?.name

      if (
        currentStepName === 'Participant Information' &&
        nextStepName === 'Review & Pay'
      ) {
        setShouldFetchClientSecret(true)
      } else {
        setShouldFetchClientSecret(false)
      }
      return nextStep
    })
  }

  const handlePrev = () => {
    setActiveStep(prevStep => {
      const prevStepIndex = prevStep - 1
      const currentStepName = steps[prevStep]?.name
      if (currentStepName === 'Review & Pay') {
        setShouldFetchClientSecret(false)
      }
      return prevStepIndex
    })
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [activeStep])

  if (loading) {
    return <CircularProgress />
  }

  if (error) {
    return <Error error={error} message={error?.message} />
  }

  if (product) {
    return <RegistrationComplete groupEvent={groupEvent} enrollment={product} />
  }

  return (
    <Layout
      activeStep={activeStep}
      handleNext={handleNext}
      handlePrev={handlePrev}
      onSubmit={onSubmit}
      shouldFetchClientSecret={shouldFetchClientSecret}
      setShouldFetchClientSecret={setShouldFetchClientSecret}
      {...props}
    />
  )
}

export default RegistrationWithPaymentIntents
